export default __webpack_public_path__ + "static/MontagueCountyTexas-0f6d4efe88843dbed05e0ff8ff5b4243.pdf";